import React from 'react';
import Signup from '../Signup';
import Footer from '../Footer';

function LoginPage() {
  return (
    <div>
      <Signup />
      <Footer />
    </div>
  );
}

export default LoginPage;
